import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation, EffectFade } from 'swiper'
import { times } from 'lodash'
import FadeImg from '@/components/fadeImg'

import { IImageData } from '@/util/types'

export default function BlogSwiper({
  imageDatas,
  isMobile
}: {
  imageDatas: IImageData[]
  isMobile: boolean
}) {
  const getImgSrc = (index: number) => {
    if (imageDatas[index] && imageDatas[index].videoUrl) {
      return `https://image.mux.com/${imageDatas[index].videoUrl}/thumbnail.png?height=440`
    }

    return imageDatas[index].imageUrl
  }

  const SwiperImg = ({ index }: { index: number }) => (
    <>
      <FadeImg
        alt="Beyond the Pines Carousel"
        style={{ width: '100%' }}
        src={getImgSrc(index)}
        disableRightClick
      />
    </>
  )

  const modules = isMobile
    ? [ Pagination ]
    : [ Pagination, Navigation, EffectFade ]

  return (
    <div className={`${isMobile ? 'blog-swiper-mb' : 'blog-swiper-dt'}`}>
      <Swiper
        modules={modules}
        slidesPerView={'auto'}
        slidesPerGroupSkip={1}
        loop={true}
        pagination={{
          type: isMobile ? 'bullets' : 'fraction'
        }}
        className="mySwiper"
        speed={100}
        centeredSlides
        {
          ...(isMobile
            ? null 
            : { 
              navigation: true,
              effect: "fade",
              fadeEffect: { crossFade: true }
            })
        }
      >
        {times(imageDatas.length, Number).map((index) => (
          <SwiperSlide key={index}>
            <SwiperImg index={index} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
